import type { ReactNode } from "react";
import { cn } from "@/utils";

type PageHeaderProps =
  | {
      actions?: ReactNode;
      description?: string;
      header?: never;
      meta?: ReactNode;
      title: string;
    }
  | {
      actions?: never;
      description?: never;
      header: ReactNode;
      meta?: never;
      title?: never;
    };

export type PageShellProps = PageHeaderProps & {
  children: ReactNode;
  className?: string;
  fill?: boolean;
  navigation?: ReactNode;
};

/** 独立工作台的统一页面骨架：导航、页头、元信息与内容区域。 */
export function PageShell({ actions, children, className, description, fill = false, header, meta, title, navigation }: PageShellProps) {
  return (
    <div
      className={cn("mx-auto flex w-full max-w-screen-2xl flex-col gap-5 py-4 px-4 lg:px-6", fill && "h-full min-h-0 overflow-hidden", className)}
      data-slot="page-shell"
    >
      {navigation ? <div className="flex min-h-8 shrink-0 items-center">{navigation}</div> : null}
      {header !== undefined ? (
        header
      ) : (
        <header className="flex shrink-0 flex-col gap-4 sm:flex-row sm:items-start sm:justify-between px-1">
          <div className="min-w-0">
            <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
            {description ? <p className="mt-1.5 text-sm text-muted-foreground">{description}</p> : null}
            {meta}
          </div>
          {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
        </header>
      )}
      {fill ? <div className="min-h-0 flex-1">{children}</div> : children}
    </div>
  );
}
